import axios from 'axios';
import { WebIntent } from '../dtos/webIntent';
import { getApiV2Url } from '../utils/api';

export async function createWebIntent(intent: WebIntent): Promise<WebIntent> {
  const { data } = await axios.post<WebIntent>(`${getApiV2Url()}/intents`, intent);

  return data;
}
